"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useAsyncGlobalVariable_1 = require("./useAsyncGlobalVariable");
var useCookieConsent = function () {
    var _a = (0, react_1.useState)(false), cookieCategory2 = _a[0], setCookieCategory2 = _a[1];
    var cc2 = (0, useAsyncGlobalVariable_1.default)(['ikea', 'cookieConsent', 'status', '2']).value;
    (0, react_1.useEffect)(function () {
        setCookieCategory2(!!cc2);
    }, [cc2]);
    var updateCookieCategory = function (e) {
        var _a;
        var newCategory = (_a = e.detail) === null || _a === void 0 ? void 0 : _a['2'];
        setCookieCategory2(!!newCategory);
    };
    (0, react_1.useEffect)(function () {
        document.addEventListener('ikeaCookieConsent', updateCookieCategory);
        return function () {
            document.removeEventListener('ikeaCookieConsent', updateCookieCategory);
        };
    }, []);
    return { cookieCategory2: cookieCategory2 };
};
exports.default = useCookieConsent;
